const escapeSingleQuotes = (text) => text.replace(/'/g, "''");

export default escapeSingleQuotes;
